import { StringValueType } from './EnumsInternal';


function IsMobileOrEmail (inputMobileOrEmail: string) {
    if (/^([2-9]{1}[\d]{7})$/.test(inputMobileOrEmail)) {
        return StringValueType.MobilePhone8;
    }
    else if (/^([\w_.]+@{1}[\w_]+[.]{1}[\w_]+([.]{1}[\w]+)?)$/.test(inputMobileOrEmail)) {
        return StringValueType.EmailAddress
    }
    else {
        return StringValueType.Invalid;
    }
}

function InputFieldValueTypeCheck(searchString: string) {
    if (/^([0-9]{1,9})$/.test(searchString)) {
        return StringValueType.NumberMax9;
    }
    else if (/^([a-zA-Z \u00e6\u00f8\u00e5\d]{3,})$/.test(searchString)) {
        return StringValueType.TextMin3;
    }
    else {
        return StringValueType.Invalid;
    }
}

function PhoneNumberSpacing(fieldString: string) {
    if (IsMobileOrEmail(fieldString) === StringValueType.MobilePhone8)
        return fieldString.match(/.{1,2}/g)?.join(' ');
    else
        return fieldString;
}


export { IsMobileOrEmail, InputFieldValueTypeCheck, PhoneNumberSpacing };
